(() => {
  if (window.__kpcCartPairingsReady) return;
  window.__kpcCartPairingsReady = true;

  document.addEventListener('click', async (event) => {
    const scrollButton = event.target.closest('[data-pairing-scroll]');
    if (scrollButton) {
      const track = scrollButton.closest('.kpc-cart-pairings').querySelector('.kpc-cart-pairings__track');
      track.scrollBy({ left: Number(scrollButton.dataset.pairingScroll) * track.clientWidth * .85, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      return;
    }
    const button = event.target.closest('[data-pairing-add]');
    if (!button || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    event.preventDefault();

    const card = button.closest('[data-cart-pairing-card]');
    const status = card?.querySelector('[data-pairing-status]');
    const originalLabel = button.textContent;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    if (status) status.textContent = 'Adding to your order…';

    try {
      const isCartPage = Boolean(button.closest('.kpc-cart-pairings--page'));
      const drawer = isCartPage ? null : document.querySelector('cart-drawer');
      const body = {
        items: [{ id: variantId, quantity: 1 }],
      };

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'This item could not be added.');
      }

      if (isCartPage) {
        window.location.reload();
        return;
      }

      if (status) status.textContent = 'Added to your order.';
      button.textContent = 'Added';

      if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
        drawer.renderContents(result);
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      if (status) status.textContent = error.message || 'This item could not be added.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalLabel;
    }
  });
})();
